// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"354":"023fd113","418":"57ef3bd9","478":"87b17adc"}[chunkId] + ".js";
};